import { request, Paginated } from "utils/api";
import { BookingParticipant, Booking, BookingOptions } from "api/bookings";

// detailed booking participant from GET /admin/bookings/details
export interface DetailedBookingParticipant extends BookingParticipant {
    checkInType?: "1st-party" | "3rd-party",
    payingPriceCents: number,
}

// detailed booking from GET /admin/bookings/details
export interface DetailedBooking extends Booking {
    optionsInfo: BookingOptions,
    participants: DetailedBookingParticipant[],
}

// fetch bookings filter params
interface GetBookingsParams {
    attachedObjects?: ("sip-feedback-form")[],
    bookingQuery?: string,
    bookingStatus?: Booking["bookingStatus"],
    bookingType?: Booking["bookingType"],
    clubId?: string,
    fromDate?: string,
    invitationStatus?: BookingParticipant["invitationStatus"],
    isPaidBooking?: boolean,
    participantQuery?: string,
    participantRole?: "standard" | "coach",
    sortKey?: "startDate" | "clubName",
    sortOrder?: "ASC" | "DESC",
    toDate?: string,
}

// fetch bookings (GET /admin/bookings)
export const getBookings = (data: GetBookingsParams & {
    limit?: number,
    offset?: number,
}) => request<Paginated<Booking>>({
    data,
    endpoint: "/admin/bookings",
    method: "get",
});

// fetch booking details (GET /admin/bookings/details)
export const getBookingDetails = (data: {
    bookingId: string,
}) => request<DetailedBooking>({
    data,
    endpoint: "/admin/bookings/details",
    method: "get",
});

// delete participant from booking (DELETE /admin/bookings/participants)
export const deleteBookingParticipant = (data: {
    bookingParticipantId: string,
}) => request<Booking>({
    data,
    endpoint: "/admin/bookings/participants",
    method: "delete",
});

// export bookings (GET /admin/bookings/exports)
export const postBookingExport = (data: GetBookingsParams) => request<{ url: string }>({
    data,
    endpoint: "/admin/bookings/exports",
    method: "post",
});

// request cancellation (POST /admin/bookings/request-cancellation)
export const postBookingRequestCancellation = (data: {
    bookingId: string,
    reason: string,
}) => request<Booking>({
    data,
    endpoint: "/admin/bookings/request-cancellation",
    method: "post",
});
